import { render } from "./App.vue?vue&type=template&id=a4170c52"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a4170c52&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__